import { useAuthContext } from '../../common/contexts/auth';
import { useEnterprises } from '../../common/contexts/enterprises';
import { type UserFlowParams } from '../AxeDevtoolsProAnalytics';
import { useUserFlow } from '../contexts/UserFlow';

export interface State {
  ready: boolean;
  data: UserFlowParams;
  userFlowId?: string;
}

const useUserFlowAnalyticsData = (): State => {
  const { user, loading: userLoading } = useAuthContext();
  const { activeEnterprise, loading: enterpriseLoading } = useEnterprises();
  const { userFlow, loading: userFlowLoading, error } = useUserFlow();

  return {
    ready: !userLoading && !enterpriseLoading && !userFlowLoading && !error,
    userFlowId: userFlow?.id,
    data: {
      userFlowId: userFlow?.id,
      isEnterprise: !!activeEnterprise,
      isCreator: !!userFlow && !!user && userFlow?.user_id === user.id,
      isLoggedIn: !!user
    }
  };
};

export default useUserFlowAnalyticsData;
